import { fetchList, postPayload } from '@bit/knotchinc.web-react-components.utils.fetch-actions';
import notifications from 'api/notifications.js';

export const FETCH_NOTIFICATION_LIST = 'FETCH_NOTIFICATION_LIST';
export const FETCHED_NOTIFICATION_LIST = 'FETCHED_NOTIFICATION_LIST';
export const SET_NOTIFICATION_LIST_FILTER = 'SET_NOTIFICATION_LIST_FILTER';
export const FETCH_ALERT_SETTINGS = 'FETCH_ALERT_SETTINGS';
export const FETCHED_ALERT_SETTINGS = 'FETCHED_ALERT_SETTINGS';

export const UPDATE_ALERT_SETTING = 'UPDATE_ALERT_SETTING';
export const UPDATED_ALERT_SETTING = 'UPDATED_ALERT_SETTING';

export const UPDATE_ALERT_RULE = 'UPDATE_ALERT_RULE';
export const UPDATED_ALERT_RULE = 'UPDATED_ALERT_RULE';

export const REMOVE_ALERT = 'REMOVE_ALERT';
export const REMOVED_ALERT = 'REMOVED_ALERT';

export const HIDE_ALERT = 'HIDE_ALERT';
export const HID_ALERT = 'HID_ALERT';

export const MARK_ALL_SEEN = 'MARK_ALL_SEEN';
export const MARKED_ALL_SEEN = 'MARKED_ALL_SEEN';

// const alertTypes = [
//   'report_ready',
//   'insight',
//   'action_required',
// ];

// const generateNotification = id => ({
//   public_id: id,
//   product: 'measurement',
//   alert_type: alertTypes[id % alertTypes.length],
//   content: 'Folder Sentiment Went Up', // report ID
//   resource_type: 'report',
//   resource_id: '1234',
//   created_at: '2015-01-01',
//   seen: false,
//   link: 'somethingsomething/blueprint',
// });

// export const fetchNotifications = (clear, count = 6) => (dispatch, getState) => fetchList({
//   clear,
//   dispatch,
//   getState,
//   store: getState().Notifications.notificationList,
//   fetchingActionType: FETCH_NOTIFICATION_LIST,
//   fetchedActionType: FETCHED_NOTIFICATION_LIST,
//   apiCall: () => {
//     const resources = [];
//     for (let i = 0; i < count; i++) {
//       resources.unshift(generateNotification(i));
//     }
//     return mockDataGenerator({
//       pagination: { current: 1, max: 1 },
//       resources,
//     }, 200);
//   },
// });

export const fetchNotifications = clear => (dispatch, getState) => fetchList({
  clear,
  dispatch,
  getState,
  store: getState().Notifications.notificationList,
  fetchingActionType: FETCH_NOTIFICATION_LIST,
  fetchedActionType: FETCHED_NOTIFICATION_LIST,
  apiCall: filters => notifications.getAlerts(filters),
});

export const fetchAlertSettings = () => (dispatch, getState) => {
  fetchList({
    dispatch,
    store: getState().Insights,
    fetchingActionType: FETCH_ALERT_SETTINGS,
    fetchedActionType: FETCHED_ALERT_SETTINGS,
    apiCall: () => notifications.getAlertSettings(),
  });
};

export const updateAlertSetting = ({ alertType, format, enabled }) => (dispatch) => {
  postPayload({
    dispatch,
    fetchingActionType: UPDATE_ALERT_SETTING,
    fetchedActionType: UPDATED_ALERT_SETTING,
    payload: { alertType, format, enabled },
    fetchingPayload: { alertType, format, enabled },
    apiCall: () => notifications.updateAlertDelivery({ alertType, format, enabled }),
  });
};

export const updateAlertRule = ({ rule_id, alertType, rule_enabled }) => (dispatch) => {
  postPayload({
    dispatch,
    fetchingActionType: UPDATE_ALERT_RULE,
    fetchedActionType: UPDATED_ALERT_RULE,
    payload: { rule_id, alertType, rule_enabled },
    fetchingPayload: { rule_id, alertType, rule_enabled },
    apiCall: () => notifications.updateAlertRule({ rule_id, rule_enabled }),
  });
};

export const removeAlert = ({ alertId }) => (dispatch) => {
  postPayload({
    dispatch,
    fetchingActionType: REMOVE_ALERT,
    fetchedActionType: REMOVED_ALERT,
    payload: { alertId },
    fetchingPayload: { alert_id: alertId },
    apiCall: () => notifications.removeAlert({ alert_id: alertId }),
  });
};

export const hideAlert = ({ alertId }) => (dispatch) => {
  postPayload({
    dispatch,
    fetchingActionType: HIDE_ALERT,
    fetchedActionType: HID_ALERT,
    payload: { alertId },
    fetchingPayload: { alert_id: alertId },
    apiCall: () => notifications.hideAlert({ alert_id: alertId }),
  });
};

export const clearAllNotifications = () => (dispatch) => {
  dispatch({ type: MARK_ALL_SEEN });
  return notifications.markAllAlertsAsSeen()
  .end((error, response) => {
    if (error) {
      dispatch({
        type: 'MARKED_ALL_SEEN',
        data: [],
        status: 'error',
      });
    } else {
      dispatch({
        type: 'MARKED_ALL_SEEN',
        data: response.body,
        status: 'success',
      });
    }
  });
};
